import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";

const ALLOWED_PLACEMENTS = new Set([
  "results_secondary",
  "results_lowscore",
  "results_footer",
  "wait_state",
  "home_secondary",
  "footer",
  "free_limit",
  "dashboard_card",
  "exit_intent",
]);

async function resolveUserIdFromAuth(): Promise<string | null> {
  try {
    const req = getRequest();
    const authHeader = req?.headers?.get("authorization");
    if (!authHeader?.startsWith("Bearer ")) return null;
    const token = authHeader.slice("Bearer ".length);
    if (!token || token.split(".").length !== 3) return null;
    const url = process.env.SUPABASE_URL;
    const key = process.env.SUPABASE_PUBLISHABLE_KEY;
    if (!url || !key) return null;
    const { createClient } = await import("@supabase/supabase-js");
    const sb = createClient(url, key, {
      auth: { storage: undefined, persistSession: false, autoRefreshToken: false },
    });
    const { data } = await sb.auth.getClaims(token);
    return (data?.claims?.sub as string | undefined) ?? null;
  } catch {
    return null;
  }
}

export const logIkomatchClick = createServerFn({ method: "POST" })
  .inputValidator((input: { placement: string; path?: string; anonToken?: string }) => {
    const placement = String(input?.placement ?? "").slice(0, 64);
    if (!ALLOWED_PLACEMENTS.has(placement)) throw new Error("invalid placement");
    const path = typeof input?.path === "string" ? input.path.slice(0, 512) : null;
    const rawTok = typeof input?.anonToken === "string" ? input.anonToken : "";
    const anonToken = rawTok.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 64) || null;
    return { placement, path, anonToken };
  })
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/admin.server");
    const userId = await resolveUserIdFromAuth();
    await supabaseAdmin.from("events").insert({
      event_name: "ikomatch_click",
      user_id: userId,
      properties: {
        placement: data.placement,
        path: data.path,
        anon_token: data.anonToken,
      },
    });
    return { ok: true as const };
  });
